<div class="modal-header border-0">
    <div class="d-flex w-100 justify-content-end align-items-center">
        <!-- <a class="text-dark" (click)="closeModal()" data-dismiss="modal" aria-label="Close">
            <app-tabler-icon [name]="_TablerIcon.X" [size]="20"></app-tabler-icon>
        </a> -->
    </div>
</div>

<div class="modal-body border-0 px-md-5 px-3 py-0" ngbAutofocus>

    <div class="d-flex justify-content-center">
        <img src="/assets/logo/logo.png" class="auth-logo" alt="" srcset="">
    </div>

    <hr>

    <div class="mb-2">
        <p class="fw-bold mb-0">ข้อตกลงและเงื่อนไขการใช้งาน</p>
        <small class="text-muted">เงื่อนไขและข้อกำหนด PDPA สำหรับการเข้าใช้งาน</small>
    </div>

    <div class="border rounded p-2 mx-2 my-3 ql-editor" (scroll)="onScrollConsent($event)"
        style="overflow-y: auto; min-height: 150px; max-height: 30vh; scrollbar-width: thin;" #scrollBox>
        <div [innerHTML]="consentDetail"></div>
    </div>


    @if (!viewOnly) {
        <div class="row ">
            <div class="col-12">
                <label class="mt-3 mb-3">
                    <div class="d-flex">
                        <input type="checkbox" [(ngModel)]="isAccept" [disabled]="!consentScrolledToBottom"
                            class="form-check-input d-block mx-auto" hidden />
                        <p class=" mb-0 ms-2">ยอมรับเงื่อนไขและข้อกำหนดการเข้าใช้งาน</p>
                    </div>
                </label>
            </div>
        </div>
    }
</div>

<div class="modal-footer border-0 justify-content-center  px-md-5 px-4 pb-4">
    @if (!viewOnly) {
        <div class="row justify-content-center">
            <button type="button" [disabled]="!isAccept" (click)="onSubmit()"
                class="py-2 btn w-100 btn-primary action-btn">
                ตกลง
            </button>
        </div>
    }@else {
        <div class="row justify-content-center">
            <button type="button" (click)="closeModal()" class="py-2 btn w-100 btn-outline-success action-btn">
                ปิด
            </button>
        </div>
    }
</div>